import { createContext, useContext } from 'react';

export const EMPTY_ATTRIBUTION = {
  params: {},
  capturedAt: null,
  expiresAt: null,
  hasAttribution: false,
  clear: () => {}
};

const CampaignContext = createContext(EMPTY_ATTRIBUTION);

/**
 * The captured campaign set: `params` holds offer, source, channel and utm_*
 * keys that were present; `clear` drops it from memory and storage (for use once
 * the values have reached the order). Outside a CampaignProvider it is empty.
 */
export const useCampaignAttribution = () => useContext(CampaignContext);

export default CampaignContext;
